import { useState } from "react";

import useCallbackRef from "@/util/use-callback-ref.mjs";

export default function useResizeObserver<E extends Element>(id = "") {
  const [contentRect, setContentRect] = useState<DOMRectReadOnly>(null);

  const callbackRef = useCallbackRef(
    (el: E) => {
      const resizeObserver =
        typeof ResizeObserver === "undefined"
          ? null
          : new ResizeObserver((entries) => {
              const rt = entries[0].contentRect;
              setContentRect(rt);
            });
      resizeObserver?.observe(el);

      return () => resizeObserver?.disconnect();
    },
    [id],
  );

  return [callbackRef, contentRect] as const;
}
